import Footer from '@components/Footer/Footer';
import Header from '@components/Header/Header';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import jobs from 'src/data/jobs.json';
import { Job } from 'src/types';
import CareersForm from './CareersForm/CareersForm';
import CareersSelector from './CareersSelector/CareersSelector';
import JobCard from './JobCard/JobCard';

import './Careers.css';

const Careers = () => {
	const [section, setSection] = useState<'open' | 'contact'>('open');
	const isOpen = section === 'open';
	const jobsArray: Job[] = jobs;
	const jobsAmount = jobsArray.length;
	const linkedinLink = (
		<a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/trueflag">
			<FormattedMessage id="linkedin-link" />
		</a>
	);
	return (
		<div id="careers" className="page">
			<Header />
			<div className="wrapper">
				{!!jobsAmount && <CareersSelector section={section} handleSection={setSection} />}

				<div className="selector-content">
					{isOpen && !!jobsAmount ? (
						<section id="jobs-grid">
							<header id="open-positions-header">
								<section id="open-amount">
									<strong>{jobsAmount}</strong>
									<span>
										<FormattedMessage id="careers-selector.open" />
									</span>
								</section>
								<section>
									<p>
										<FormattedMessage id="careers-selector.open-header" values={{ linkedinLink }} />
									</p>
								</section>
							</header>
							{jobsArray.map((j: Job) => (
								<JobCard key={j.id} job={j} />
							))}
						</section>
					) : (
						<article className="careers-card">
							{!jobsAmount && (
								<h1>
									<FormattedMessage id="careers-selector.contact" />
								</h1>
							)}
							<CareersForm />
						</article>
					)}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Careers;
